<template xmlns:v-touch="http://www.w3.org/1999/xhtml">
  <v-container :fill-height="loading" class="user-settings" fluid pt-0>
    <v-app-bar app color="black" dark fixed>

      <template v-if="$vuetify.breakpoint.mdAndDown">
        <hb-main-menu-button/>
      </template>

      <v-toolbar-title v-if="!loading" style="margin-left: 0">{{ $tc('valintatyyppi.title', 2) }}</v-toolbar-title>

      <v-spacer></v-spacer>
    </v-app-bar>

    <hb-loading-indicator v-if="loading" align-middle fill-height></hb-loading-indicator>

    <v-fade-transition hide-on-leave>
      <v-row v-if="!loading">
        <v-col class="mt-2" cols="12" offset-xl="1" xl="10">
          <v-row>
            <v-col cols="12">
              <v-card color="#191919" outlined>
                <v-card-title primary-title>

                  {{ $tc('valintatyyppi.title', 2) }}
                  <v-spacer></v-spacer>

                  <v-btn color="primary" icon @click="openEdit(null)">
                    <v-icon>mdi mdi-plus</v-icon>
                  </v-btn>
                </v-card-title>

                <v-divider/>
                <v-card-text>
                  <v-col cols="12" md="2">
                    <v-autocomplete v-model="vuosi" :items="vuodet" :label="$t('year')" hide-details></v-autocomplete>
                  </v-col>
                </v-card-text>
                <v-divider/>
                <v-card-text>
                  <v-data-table :group-by="['_groupBy']" :headers="headers" :items="filteredValintatyypit" class="mt-2"
                                disable-pagination
                                hide-default-footer
                  >
                    <template v-slot:item.vastuualue="{item}">
                      {{ item.vastuualue && item.vastuualue.nimi }}
                    </template>
                    <template v-slot:item._="{item}">
                      <v-btn icon @click="openEdit(item)">
                        <v-icon small>mdi mdi-pencil</v-icon>
                      </v-btn>
                    </template>
                    <template v-slot:group.header="{items}">
                      <td class="text-subtitle-1 primary" colspan="100%">{{ items[0].vastuualue.nimi }}</td>
                    </template>
                  </v-data-table>
                </v-card-text>
              </v-card>
              <v-dialog v-model="showEditDialog" max-width="600">
                <v-form ref="form">


                  <v-card>
                    <v-card-title>
                      {{ $tc('valintatyyppi.title', 1) }}
                    </v-card-title>
                    <v-divider/>
                    <v-card-text>
                      <v-row>
                        <v-col class="mt-2" cols="12">
                          <v-text-field v-model="edit.nimi"
                                        :disabled="saving"
                                        :label="$t('valintatyyppi.nimi')"
                                        :rules="[$rules.required]"
                                        class="required"
                                        type="text"
                                        validate-on-blur
                          ></v-text-field>
                          <v-select v-model="edit.vastuualueId"
                                    :disabled="saving"
                                    :item-text="(item) => item.nimi"
                                    :items="vastuualueet"
                                    :label="$tc('vastuualue.title',1)"
                                    :rules="[$rules.required]"
                                    class="required"
                                    item-value="id"
                                    validate-on-blur
                          ></v-select>
                          <v-text-field v-model.number="edit.vuosi"
                                        :disabled="saving"
                                        :label="$t('valintatyyppi.vuosi')"
                                        :rules="[$rules.required]"
                                        class="mt-2 required"
                                        type="number"
                                        validate-on-blur></v-text-field>
                          <v-text-field v-model.number="edit.jarjestysnumero"
                                        :disabled="saving"
                                        :label="$t('valintatyyppi.jarjestysnumero')"
                                        class="mt-2"
                                        type="number"
                                        validate-on-blur></v-text-field>
                        </v-col>
                      </v-row>


                    </v-card-text>
                    <v-divider/>
                    <v-card-actions :class="$vuetify.breakpoint.xsOnly && 'flex-column-reverse'">
                      <v-btn
                          v-if="edit.id"
                          :block="$vuetify.breakpoint.xsOnly"
                          :class="$vuetify.breakpoint.xsOnly ? 'ma-1' : ''"
                          :large="$vuetify.breakpoint.xsOnly"
                          :loading="deleting"
                          :text="$vuetify.breakpoint.smAndUp"
                          color="error"
                          @click="deleteValintatyyppi"
                      >
                        {{ $t('delete') }}
                      </v-btn>
                      <v-spacer></v-spacer>
                      <v-btn
                          :block="$vuetify.breakpoint.xsOnly"
                          :class="$vuetify.breakpoint.xsOnly ? 'ma-1' : ''"
                          :large="$vuetify.breakpoint.xsOnly"
                          :text="$vuetify.breakpoint.smAndUp"
                          @click="closeDialog"
                      >
                        {{ $t('cancel') }}
                      </v-btn>
                      <v-btn
                          :block="$vuetify.breakpoint.xsOnly"
                          :class="$vuetify.breakpoint.xsOnly ? 'ma-1' : ''"
                          :large="$vuetify.breakpoint.xsOnly"
                          :loading="saving"
                          color="primary"
                          @click="save"
                      >
                        {{ $t('save') }}
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-form>
              </v-dialog>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-fade-transition>
  </v-container>
</template>

<script>
import api from '../apicollection';
import orderBy from "lodash/orderBy";
import dayjs from "dayjs";

export default {
  name: 'ValintatyyppiAsetuksetView',
  data() {
    return {
      loading: true,
      valintatyypit: [],
      vastuualueet: [],
      edit: {},
      vuosi: dayjs().year(),
      saving: false,
      showEditDialog: false,
      deleting: false,
      headers: [
        {
          text: this.$t('valintatyyppi.nimi'),
          value: 'nimi'
        },
        {
          text: this.$t('valintatyyppi.vuosi'),
          value: 'vuosi'
        },
        {
          text: this.$tc('vastuualue.title', 1),
          value: 'vastuualue'
        },
        {
          text: this.$t('valintatyyppi.jarjestysnumero'),
          value: 'jarjestysnumero'
        },
        {
          text: '',
          value: '_'
        }
      ]
    };
  },
  computed: {
    filteredValintatyypit() {
      return orderBy(this.valintatyypit.filter(v => v.vuosi === this.vuosi).map(v => {
        v._groupBy = `${v.vastuualue.jarjestysnumero}_${v.vastuualueId}`;
        return v;
      }), ['vuosi', 'vastuualue.jarjestysnumero', 'jarjestysnumero'], ['desc', 'asc', 'asc'])
    },
    vuodet() {
      return this.$years;
    },
  },
  methods: {
    async getValintatyypit() {
      const valintatyypit = await api.getValintatyypit();
      this.valintatyypit = valintatyypit;
    },
    async getVastuualueet() {
      const vastuualueet = await api.getVastuualueet();
      this.vastuualueet = vastuualueet;
    },
    openEdit(item) {
      this.showEditDialog = true;
      this.edit = item || {};
    },
    closeDialog() {
      this.showEditDialog = false;
    },
    async deleteValintatyyppi() {
      this.deleting = true;
      const valinnat = await api.getValinnat(this.edit.vastuualue, this.edit.vuosi);
      if ((valinnat || []).filter(v => v.valintatyyppiId === this.edit.id).length > 0) {
        this.$showErrorNotification(this.$t('errors.error_deleting_valintatyyppi_valinta_existing'));
        this.deleting = false;
        return false;
      }
      if (!await this.$confirmDelete(this.$t('valintatyyppi.delete_valintatyyppi'))) {
        this.deleting = false;
        return false;
      }

      try {
        await api.deleteValintatyyppi(this.edit);
        this.closeDialog();
        this.reload();
      } catch (e) {
        console.error(e);
        this.$showErrorNotification(this.$t('errors.error_deleting_valintatyyppi'))
      }
      this.deleting = false;
    },
    async save() {
      const valintatyyppi = {...this.edit};
      if (!this.$refs.form.validate()) return;
      this.saving = true;
      try {
        if (valintatyyppi.id) {
          await api.updateValintatyyppi(valintatyyppi);
        } else {
          await api.createValintatyyppi(valintatyyppi);
        }

        this.closeDialog();
        this.reload();
      } catch (e) {
        this.$showErrorNotification(this.$t('errors.error_saving_valintatyyppi'))
      } finally {
        this.saving = false;
      }
    },
    async reload() {
      this.loading = true;
      await Promise.all([this.getValintatyypit(), this.getVastuualueet()])
      this.loading = false;
    }
  },
  async mounted() {
    await this.reload();


    this.$vuetify.goTo(0, {
      duration: 0,
      offset: 0,
    });
  },
};
</script>

<style lang="scss" scoped></style>
